import type { User } from "@/types";

/**
 * Who teaches.
 *
 * The owner is a teacher too. They can host a lesson and write a scene from
 * the day the institution is created, without adding themselves to anything,
 * and every list that offers teachers offers them — marked, so the owner
 * reading their own name understands why it is there.
 */
export function isTeachingRole(person: Pick<User, "role">): boolean {
  return person.role === "teacher" || person.role === "owner";
}

/** Teaching staff who can be put on a group today — a disabled account cannot. */
export function isTeachingStaff(person: User): boolean {
  return isTeachingRole(person) && !person.disabled;
}

export function teachingStaff(people: readonly User[]): User[] {
  return people.filter(isTeachingStaff);
}

/**
 * The mark beside an owner's name in a list of teachers.
 *
 * "you, owner" for the person reading; "owner" for anyone else's owner; nothing
 * for a teacher. A key rather than text, so the German build says it in German.
 */
export function ownerMarkKey(person: User, meUid: string | undefined): string | undefined {
  if (person.role !== "owner") return undefined;
  return person.uid === meUid ? "people.mark.youOwner" : "people.mark.owner";
}
